import { CssBaseline } from '@mui/material'
import {
  createTheme,
  StyledEngineProvider,
  ThemeProvider as MUIThemeProvider,
} from '@mui/material/styles'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import UIStore from 'src/mobx/ui'

import componentsOverride from './overrides'
import { palettes } from './palette'
import { buildCustomShadows, buildShadows } from './shadows'
import typography from './typography'

const ThemeProvider = observer(({ children }: any) => {
  const themeName = UIStore.appTheme

  const themeOptions = useMemo(() => {
    const palette = palettes[themeName] ?? palettes.classic
    return {
      palette,
      shape: { borderRadius: 8 },
      typography,
      shadows: buildShadows(palette),
      customShadows: buildCustomShadows(palette),
    }
  }, [themeName])

  const theme = createTheme(themeOptions as any)
  theme.components = componentsOverride(theme)

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  )
})

export default ThemeProvider
